export default __webpack_public_path__ + "static/media/step_img_3.49e47d9d.png";